import request from '@/util/request';
import qs from 'qs';

// 入库单分页列表
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/warehouse/inbound/page', Object.assign({}, options, { params }));

// 入库单详情-基础信息
export const getDetailApi = (params, options) =>
  request.get('/api/v4ward/warehouse/inbound/detail', Object.assign({}, options, { params }));

// 入库单详情-物料列表
export const getGoodListByInOrderApi = (params, options) =>
  request.get(
    '/api/v4ward/warehouse/inbound/consumable/getConsumableListByInboundId',
    Object.assign({}, options, { params })
  );

// 新增入库单
export const addApi = (params, options) =>
  request.post('/api/v4ward/warehouse/inbound/submit', params, options, {
    'Content-Type': 'application/json',
  });

// 新增入库的导入模板
export const uploadExcelMaterialApi = (params, options) =>
  request.post('/api/v4ward/warehouse/inbound/uploadExcelMaterial', params, options);
  
// 获取调拨单列表
export const getTransferOrderListApi = (params, options) =>
  request.get(
    '/api/v4ward/warehouse/inbound/getAllotInboundInformation',
    Object.assign({}, options, { params })
  );

// 根据调拨单获取物料列表
export const getTransferGoodsListByIdApi = (params, options) =>
  request.get(
    '/api/v4ward/warehouse/inbound/getAllotInboundMaterialInformation',
    Object.assign({}, options, { params })
  );
